import React from 'react';
import { ExpectationSettingDemo } from './ExpectationSettingDemo';
import { HumanInTheLoopDemo } from './HumanInTheLoopDemo';
import { AgentProgressDemo } from './AgentProgressDemo';
import { GracefulFailureDemo } from './GracefulFailureDemo';
import { ClarificationDemo } from './ClarificationDemo';
import { DecisionExplanationDemo } from './DecisionExplanationDemo';
import { UndoAgentActionDemo } from './UndoAgentActionDemo';
import { PermissionScopingDemo } from './PermissionScopingDemo';
import { TopicBoundariesDemo } from './TopicBoundariesDemo';
import { VoiceSilenceDemo } from './VoiceSilenceDemo';
import { NoScreenOrientationDemo } from './NoScreenOrientationDemo';
import { ActionLogDemo } from './ActionLogDemo';
import { AgentScopeDemoAgentic } from './AgentScopeDemoAgentic';
import { GracefulFailureDemoVoice } from './GracefulFailureDemoVoice';
import { ClarificationDemoVoice } from './ClarificationDemoVoice';
import { HumanInTheLoopDemoAgentic } from './HumanInTheLoopDemoAgentic';
import { ConfidenceDisclosureDemo } from './ConfidenceDisclosureDemo';
import { ConfidenceDisclosureDemoAgentic } from './ConfidenceDisclosureDemoAgentic';
import { ProgressiveOnboardingDemo } from './ProgressiveOnboardingDemo';
import { ProgressiveOnboardingDemoAgentic } from './ProgressiveOnboardingDemoAgentic';
import { ConversationResetDemo } from './ConversationResetDemo';
import { ConversationResetDemoVoice } from './ConversationResetDemoVoice';
import { ErrorRecoveryDemo } from './ErrorRecoveryDemo';
import { ErrorRecoveryDemoAgentic } from './ErrorRecoveryDemoAgentic';
import { ErrorRecoveryDemoVoice } from './ErrorRecoveryDemoVoice';
import { DecisionExplanationDemoAgentic } from './DecisionExplanationDemoAgentic';
import { ExpectationSettingDemoAgentic } from './ExpectationSettingDemoAgentic';
import { GracefulFailureDemoAgentic } from './GracefulFailureDemoAgentic';
import { TopicBoundariesDemoVoice } from './TopicBoundariesDemoVoice';
import { PermissionScopingDemoAgentic } from './PermissionScopingDemoAgentic';
import { SourceAttributionDemo } from './SourceAttributionDemo';
import { PlanPreviewDemoAgentic } from './PlanPreviewDemoAgentic';
import { VisibleMemoryDemo } from './VisibleMemoryDemo';

export const demos: Record<string, React.ComponentType> = {
  'expectation-setting-for-ai-output': ExpectationSettingDemo,
  'human-in-the-loop-checkpoint': HumanInTheLoopDemo,
  'agent-progress-communication': AgentProgressDemo,
  'graceful-agent-failure': GracefulFailureDemo,
  'clarification-without-interrogation': ClarificationDemo,
  'decision-explanation-on-demand': DecisionExplanationDemo,
  'undo-agent-actions': UndoAgentActionDemo,
  'permission-scoping': PermissionScopingDemo,
  'graceful-topic-boundaries': TopicBoundariesDemo,
  'designing-for-silence-voice-ui': VoiceSilenceDemo,
  'no-screen-orientation-voice': NoScreenOrientationDemo,
  'autonomous-action-log': ActionLogDemo,
  'agent-scope-definition': AgentScopeDemoAgentic,
  'graceful-agent-failure-voice': GracefulFailureDemoVoice,
  'clarification-without-interrogation-voice': ClarificationDemoVoice,
  'human-in-the-loop-checkpoint-agentic': HumanInTheLoopDemoAgentic,
  'confidence-disclosure-chat': ConfidenceDisclosureDemo,
  'confidence-disclosure-agentic': ConfidenceDisclosureDemoAgentic,
  'progressive-onboarding-chat': ProgressiveOnboardingDemo,
  'progressive-onboarding-agentic': ProgressiveOnboardingDemoAgentic,
  'conversation-reset-recovery-chat': ConversationResetDemo,
  'conversation-reset-recovery-voice': ConversationResetDemoVoice,
  'graceful-error-recovery-chat': ErrorRecoveryDemo,
  'graceful-error-recovery-agentic': ErrorRecoveryDemoAgentic,
  'graceful-error-recovery-voice': ErrorRecoveryDemoVoice,
  'decision-explanation-on-demand-agentic': DecisionExplanationDemoAgentic,
  'expectation-setting-for-ai-output-agentic': ExpectationSettingDemoAgentic,
  'graceful-agent-failure-agentic': GracefulFailureDemoAgentic,
  'graceful-topic-boundaries-voice': TopicBoundariesDemoVoice,
  'permission-scoping-agentic': PermissionScopingDemoAgentic,
  'source-attribution-chat': SourceAttributionDemo,
  'plan-preview-and-live-progress-agentic': PlanPreviewDemoAgentic,
  'visible-agent-memory-chat': VisibleMemoryDemo,
};
